import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'full_name',
        title: i18n.t('marketing.manage_table.full_name'),
        sortable: true,
        width: 120,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.hashid + '/details">'+row.full_name+'</a>'
        },
    },
    {
        field: 'marketing_level',
        title: i18n.t('marketing.dashboard.level'),
        sortable: true,
        width: 130,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('marketing.manage_table.register_date'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'subsets_number',
        title: i18n.t('marketing.manage_table.subsets_number'),
        sortable: true,
        width: 100,
        textAlign: 'center',
    },

]
